import React from 'react';
import PropTypes from 'prop-types';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { YEAR_MONTH_FORMAT, PRODUCE_STRING } from './constants';
import { finalValuesCases } from './functions';

/**
 *
 * props:
 *  produces: permite especificar el tipo de dato que generará el componente
 *  al momento de establecer un valor. Los valores posibles son string o date
 *
 *  format: permite especificar el formato con que se mostrarán las fechas
 *  por defecto se utiliza YYYY-MM-DD
 */

// TODO: corregir alerta de moment al momento de borrar el valor del input desde el teclado

function YearMonthPickerBase({
  produces,
  format,
  label,
  field,
  disablePast,
  disableFuture,
  minDate,
  maxDate,
  form: {
    setFieldValue, errors, touched, setFieldTouched,
  },
  field: { name, value },
  ...rest
}) {
  const hasError = touched[name] && Boolean(errors[name]);
  return (
    <KeyboardDatePicker
      fullWidth
      views={['year', 'month']}
      autoComplete="off"
      inputVariant="outlined"
      margin="dense"
      name={name}
      clearable
      autoOk
      error={hasError}
      helperText={hasError && errors[name]}
      label={label}
      format={format}
      clearLabel="Limpiar"
      okLabel="Aceptar"
      cancelLabel="Cancelar"
      todayLabel="Hoy"
      value={value || null}
      disablePast={disablePast}
      disableFuture={disableFuture}
      animateYearScrolling={false}
      minDate={minDate}
      maxDate={maxDate}
      onChange={(valueToSet) => {
        let finalValue = valueToSet;
        if (valueToSet) {
          finalValue = finalValuesCases(finalValue, produces, format);
        }
        setFieldTouched(name, true);
        setFieldValue(name, finalValue);
      }}
      {...rest}
    />
  );
}

YearMonthPickerBase.defaultProps = {
  produces: PRODUCE_STRING,
  label: '',
  format: YEAR_MONTH_FORMAT,
  disablePast: false,
  disableFuture: false,
  maxDate: '3050-01-01',
};

YearMonthPickerBase.propTypes = {
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  produces: PropTypes.string,
  disablePast: PropTypes.bool,
  disableFuture: PropTypes.bool,
  label: PropTypes.string,
  field: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.instanceOf(Date),
      PropTypes.string,
    ]),
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  format: PropTypes.string,
  form: PropTypes.shape({
    errors: PropTypes.shape(),
    touched: PropTypes.shape(),
    setFieldTouched: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
  }).isRequired,
};

export default YearMonthPickerBase;
